import { getTableName } from 'pages/ValuationsAllocation/util/getApproachTableName/getApproachTableName';

const CELL_REF = '\\$?[A-Za-z]+\\$?\\d+';
const EXCEL_SHEET_CELL_REF = new RegExp(`(?:'([^']+)'|([A-Za-z_][\\w.]*))!(${CELL_REF})`, 'g');

// Excel Sheet2!A1 must become Sheet2.A1 so the preview looks up that sheet instead of the active one.

const toWorkbookCellKey = (cellRef: string): string => cellRef.replaceAll('$', '').toUpperCase();

export const rewriteExcelCrossSheetRefs = (expr: string): string => {
  if (!expr || !expr.includes('!')) {
    return expr;
  }

  return expr.replace(
    EXCEL_SHEET_CELL_REF,
    (_match, quotedName: string | undefined, plainName: string | undefined, cellRef: string) => {
      const sheetName = getTableName(quotedName ?? plainName ?? '');
      return `${sheetName}.${toWorkbookCellKey(cellRef)}`;
    }
  );
};
